import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { iif, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { UserContextState } from '../../models/user-context.model';
import { UserContextService } from '../../services/user-context-service/user-context.service';

export const consentGuard: CanActivateFn = () => {
  const userContextService: UserContextService = inject(UserContextService);
  const router: Router = inject(Router);

  return userContextService
    .getAuthenticatedUser()
    .pipe(switchMap(user => iif(() => user.state !== UserContextState.CONSENTED, of(router.parseUrl('/consent')), of(true))));
};
